module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/3@2x_e47490a7936f1de9492e9694bad13845.png";